import * as listsStatic from '../../../../features/lists/shared/constants/lists.static';

export const LISTS_DATA = listsStatic.LISTS_ROUTE_DATA;
export const LISTS_TABLE_HEADERS = listsStatic.LISTS_HEADERS;
export const LISTS_ACTION_BTN = [listsStatic.CONTEXT_MENU_BUTTON];
export const LISTS_SEARCH_BAR_ACTION_BTNS =
    listsStatic.SEARCH_BAR_ACTION_BUTTONS;
